module.exports = __webpack_public_path__ + "static/media/b1.32fb2120.jpg";